import { Component, computed, inject, input, OnInit } from '@angular/core';
import { Store, Uuid } from '@softline/core';
import { SOFTLINE_FEATURE_MESSAGE_BAR } from '../message-bar.shared';
import * as MessageBarStore from '../message-bar.store';
import { MessageBarConfig } from '../data/message-bar.config';
import { animate, animateChild, query, style, transition, trigger } from '@angular/animations';
import { MessageBarService } from '../message-bar.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { MessageBarComponent } from './message-bar/message-bar.component';

@Component({
    selector: 'soft-message-bar-container',
    imports: [MessageBarComponent],
    templateUrl: './message-bar-container.component.html',
    styleUrls: ['./message-bar-container.component.css'],
    standalone: true
})
export class MessageBarContainerComponent implements OnInit {
  service = inject(MessageBarService);

  //TODO: remove if removed Store
  private storeMessageBars = toSignal(
    this.store.observe(SOFTLINE_FEATURE_MESSAGE_BAR, MessageBarStore.getters.items)
  , {initialValue: []})

  messageBars = computed(() => {
    const messages = [...this.service.messageBars(), ...this.storeMessageBars()];
    return messages;
  })

  constructor(readonly store: Store) {}

  ngOnInit(): void {}

  onDismiss(uuid: Uuid): void {
    this.service.close(uuid);
  }
}
